const ENV = process.env.REACT_APP_ENV || "production";
console.log("ENV:", ENV); // Debugging output

const apiConstants = {
  GET_API_URL:
    ENV === "production"
      ? "https://castapi.aristocast.net/cms/"
      : ENV === "local"
      ? "https://castapidev.aristocast.net/cms/"
      : "https://castapidev.aristocast.net/cms/", // Default to development
};

export const ZOHO_HELP_CENTER_LOGOUT = {
  LOGOUT_URL: "https://support.intellidash.net/portal/en/home?logout=true",
};

export const SOCKET_IO_URL = {
  API_URL:
    ENV === "production"
      ? "https://castapi.aristocast.net"
      : "https://castapidev.aristocast.net",
};

export const INSIGHTS_URL = {
  CAST_API_URL:
    ENV === "production"
      ? "https://castapi.aristocast.net/cms/"
      : ENV === "local"
      ? "https://localhost/api/castApi/"
      : "https://castapidev.aristocast.net/cms/", // Default to development
};

export default apiConstants;
